// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 0.698242L10 4.03158V10.8649L15 6.69824L22 12.5316V22H18.5V15H11.5V22H2V4.03158L6 0.698242ZM8 20V4.96833L6 3.30166L4 4.96833V20H8Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.5 22V17H16.5V22H13.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-2-filled')
export default class City2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-2-filled',
    }
  }
}
